// TODO: Validate for start
export const SHAREPOINT_SERVICE_URI = process.env.REACT_APP_SHAREPOINT_SERVICE_URI as string;
export const SHAREPOINT_URI = process.env.REACT_APP_SHAREPOINT_URL as string;
export const IDENTITY_SERVICE_URI = process.env.REACT_APP_IDENTITY_SERVICE_URI as string;
export const CUSTOMER_PORTAL_URI = process.env.REACT_APP_CUSTOMER_PORTAL_URI as string;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY as string;